import { Predicates } from "../../../libraries/predicates/predicates";
import { MasterArtworkCollectionState } from "../../../states/meta-artwork/collections/data.type";
import { CreateArtworkCollectionState } from "../../artwork/state/collection/create/data";

export const formatCollectionOptions = (item: any| null) => {
  return Predicates.isNotNullAndNotUndefined(item)
    ? {
      value: item,
      label: `${item.code} - ${item.name}`,
    }
    : null;
}

export const getCollections = (collections: any[]) =>
  collections.map(formatCollectionOptions).filter(Predicates.isNotNullAndNotUndefined)
